import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { DisplayAction } from 'src/app/model/map-actions/display-actions';
import { SearchViewComponent } from '../search-view/search-view.component';
import { SLLayer } from 'src/app/model/sl-layer';
import { ModalMessagerService } from 'src/app/modal-messager/modal-messager.service';
import { AttributeInfo } from 'src/app/types/@types/sl-v-types';

@Component({
	selector: 'app-att-condition-view',
	templateUrl: './att-condition-view.component.html',
	styleUrls: ['./att-condition-view.component.scss']
})
export class AttConditionViewComponent implements OnInit {

	@ViewChild('searchCriteria') searchCriteria: SearchViewComponent;

	name = 'Attribution Condition'
	layer: SLLayer;
	attribute: AttributeInfo;

	constructor(private domNode: ElementRef, private messager: ModalMessagerService) { }

	SetAttribute(layer: SLLayer, attribute: AttributeInfo) {
		this.layer = layer;
		this.attribute = attribute;
		this.searchCriteria.SetMap(layer.map);
		this.searchCriteria.SelectLayer(layer);
	}
	public UpdateHeight(primaryHeight, panelMax) {
		this.domNode.nativeElement.style.height = panelMax + 'px';
	}
	Back() {
		this.messager.Confirm('Clicking ok below will return to the attribute view without committing any changes below. If you want to return and keep your changes click cancel below and use the Continue button in the panel.',
			() => {
				DisplayAction.SetPrimaryView('layer-attribute-view');
			},
			() => { }
		)
	}
	Continue() {
		this.messager.Confirm('Continuing will commit the inormation above to your layer locally. It will not be saved to the server until you save the attribute. To return to the attribute view without committing changes click cancel below and click the red button with an x in the upper right of the panel.',
			() => {
				this.attribute.conditions = this.searchCriteria.GetCriteria();
				DisplayAction.SetPrimaryView('layer-attribute-view');
			}, () => { }, 'Before you go...');
	}
	Revert() {
		this.searchCriteria.DeleteAll();
		if(!!this.attribute.conditions) {
			for(const criteria of this.attribute.conditions) {
				this.searchCriteria.AddCriteria(criteria);
			}
		}
	}
	RequestExport() {

	}
	RequestImport() {

	}

	ngOnInit(): void {
	}

}
